import LandingPage from "@/components/LandingPage";

const internal = [
  { label: "Motorsport-Videoproduktion", to: "/motorsport-videoproduktion" },
  { label: "Sport-Content", to: "/sport-content" },
  { label: "Eventfilm", to: "/eventfilm" },
  { label: "Videoproduktion Ruhrgebiet", to: "/videoproduktion-ruhrgebiet" },
  { label: "Alle Leistungen", to: "/leistungen" },
];

const VideoproduktionBochum = () => (
  <LandingPage
    path="/videoproduktion-bochum"
    metaTitle="Videoproduktion Bochum | Cinematic Filmagentur 4FaceMedia"
    metaDescription="Videoproduktion in Bochum: Imagefilm, Eventfilm, Motorsport- & Sport-Content. Cinematic, planbar & lokal verankert. Jetzt Projekt anfragen."
    eyebrow="Videoproduktion · Bochum · Ruhrgebiet"
    h1={
      <>
        Videoproduktion <span className="text-gradient">aus Bochum</span>.
      </>
    }
    intro="Wir sind eure Videoproduktion in Bochum – mit Spezialisierung auf Motorsport, Sport, Eventbegleitung & Content. Lokal verankert, deutschlandweit im Einsatz."
    serviceName="Videoproduktion Bochum"
    serviceDescription="Cinematic Videoproduktion mit Sitz in Bochum. Imagefilme, Eventfilme, Motorsport- und Sport-Content für Unternehmen, Vereine und Veranstalter."
    areaServed={["Bochum", "Dortmund", "Essen", "Herne", "Witten", "Ruhrgebiet", "Nordrhein-Westfalen"]}
    bullets={[
      { title: "Lokal & schnell vor Ort", text: "Kurze Wege im Ruhrgebiet, kurzfristige Drehs, persönliche Betreuung – kein Pitch-Deck-Marathon." },
      { title: "Imagefilme für Unternehmen", text: "Wir erzählen, wofür euer Unternehmen steht – authentisch, modern und auf Conversion ausgerichtet." },
      { title: "Eventfilm & Aftermovies", text: "Cinematic Eventbegleitung für Firmenevents, Galas und Großveranstaltungen in Bochum & Umgebung." },
      { title: "Motorsport & Sport", text: "Spezialisierung auf Motorsport- und Sport-Content – mit Strecken-Know-how und schneller Auslieferung." },
      { title: "Foto & Video aus einer Hand", text: "Konsistente Bildsprache, ein Ansprechpartner – Fotograph und Bewegtbild parallel produziert." },
      { title: "Planbar & transparent", text: "Festpreis-Angebote, klare Deadlines, dokumentierter Workflow." },
    ]}
    faqs={[
      { q: "Sitzt ihr wirklich in Bochum?", a: "Ja. Unser Standort ist Bochum, von hier aus arbeiten wir im gesamten Ruhrgebiet, in NRW und deutschlandweit." },
      { q: "Wie schnell könnt ihr in Bochum vor Ort sein?", a: "Bei kurzfristigen Anfragen meist innerhalb weniger Tage, in Notfällen auch innerhalb von 24 Stunden – sofern Crew und Equipment verfügbar sind." },
      { q: "Macht ihr nur lokale Projekte?", a: "Nein. Bochum ist unser Sitz, Drehs realisieren wir bundesweit – Reisetage werden im Angebot transparent ausgewiesen." },
      { q: "Welche Branchen betreut ihr in Bochum?", a: "Schwerpunkt sind Motorsport, Sport, Eventbegleitung und Content. Daneben Branding, Webdesign und Social Media für Unternehmen aus dem Ruhrgebiet." },
    ]}
    internalLinks={internal}
  />
);

export default VideoproduktionBochum;
